import { HttpLink } from '@apollo/client';
import nodeFetch from 'node-fetch';

import type { Metrics } from '../types';

import {
  type Brands,
  type CountryCode,
  type SeekHeaders,
  getSeekHeaders,
} from './getSeekHeaders';
import getTrackingHeaders from './getTrackingHeaders';
import { formatMetrics } from './metrics';

const fetch =
  (
    appName: string,
    trackingHeaders: { [headers: string]: string },
    seekHeaders: SeekHeaders,
    headers: Record<string, any>,
    metricsHandler?: (metrics: Metrics) => void,
  ) =>
  (url: string, options: RequestInit) => {
    options.headers = {
      ...headers,
      ...options.headers,
      ...trackingHeaders,
      ...seekHeaders,
      'X-Seek-Site': appName,
    };

    const startTime = Date.now();

    // RequestInit from 'node-fetch' doesn't match up with global typescript/apollo one
    // @ts-ignore
    return nodeFetch(url, options).then((response: Response) => {
      metricsHandler?.(formatMetrics(startTime, response));
      return response;
    });
  };

interface HttpClientOptions {
  appName: string;
  graphqlEndpointOverride?: string;
  headers?: Record<string, any>;
  brand?: Brands;
  country?: CountryCode;
  metricsHandler?: (metrics: Metrics) => void;
}

export const nodeHttpLink = ({
  appName,
  headers = {},
  graphqlEndpointOverride,
  brand,
  country,
  metricsHandler,
}: HttpClientOptions) => {
  const trackingHeaders = getTrackingHeaders();
  const seekHeaders = getSeekHeaders({
    brand,
    country,
  });

  return new HttpLink({
    uri: graphqlEndpointOverride ?? '/graphql',
    // @ts-ignore RequestInit from 'node-fetch' doesn't match up with global typescript/apollo one
    fetch: fetch(
      appName,
      trackingHeaders,
      seekHeaders,
      headers,
      metricsHandler,
    ),
  });
};

export { fetch as fetchForTest };
